// compact removes falsy values from an array.
export function compact<T>(array: T[]): T[] {
  return array.filter(Boolean);
}

// strictCompact removes nulls and undefineds from an array.
export function strictlyCompact<T>(array: T[]): NonNullable<T>[] {
  return array.filter((item) => item !== undefined && item !== null);
}
